import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { RouterModule } from "@angular/router";
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataTableModule } from "angular2-datatable";
import { SiniestralidadEmpresaServices } from "./siniestralidad.service";
import { SiniestralidadEmpresaComponent } from "./siniestralidad.component";
import { CalendarModule } from 'primeng/primeng';
import {ResumenComponent} from './resumen.component';
import {DetalleDiagnosticoComponent} from './detalle-diagnostico.componet';
import { ChartsModule } from 'ng2-charts'
import { MaternidadComponent } from "./maternidad.component";
import { ProveedoresComponent } from "./proveedores.component";
import { RankingTitularesComponent } from "./rankingTitulares.component";

@NgModule({
    declarations: [SiniestralidadEmpresaComponent, ResumenComponent, DetalleDiagnosticoComponent, MaternidadComponent, ProveedoresComponent,RankingTitularesComponent],
    imports: [BrowserModule, HttpModule, FormsModule, BrowserAnimationsModule, RouterModule, DataTableModule,CalendarModule,
        ChartsModule],
    exports: [SiniestralidadEmpresaComponent],
    providers: [SiniestralidadEmpresaServices]
})

export class SiniestralidadEmpresaModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/siniestralidad/siniestralidad.module.ts